/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;

  //console.log(new Date().toLocaleDateString("en-CA"));
  var checkFinancial = function checkFinancial() {
    $f7.request({
      method: 'get',
      url: window.path + 'static/api/ledgerV2.php?action=get_transaction&AccountNumber=' + localStorage.getItem("AccountNumber") + '&Email=' + localStorage.getItem("Email"),
      success: function success(data) {
        console.log("Output:" + data);
        data = JSON.parse(data);
        var financialCard = "";

        for (var i = 0; i < data.length; i++) {
          var debit = "";
          var credit = "";
          var color = "";

          if (data[i].Amount > 0) {
            debit = "$" + parseFloat(data[i].Amount).toFixed(2);
            color = "up";
          } else {
            credit = "$" + parseFloat(data[i].Amount).toFixed(2);
            color = "down";
          }

          if (data[i].Code == "C002") debit = "<span class='badge color-blue'> Process </span>";
          var arr = data[i].DateTime.split(" ");
          financialCard += "\n        <tr>\n          <td class=\"label-cell\"><span style=\"font-size:10px;color:gray\">" + arr[0] + "<BR/>" + arr[1] + arr[2] + "</span></td>\n          <td class=\"label-cell\"><span style=\"font-size:10px;\"><img src=\"static/images/arrow-" + color + ".png\" style=\"width:20px;vertical-align:middle\"/> " + data[i].Description + "</span></td>\n          <td class=\"numeric-cell\" style=\"text-align:center;color:greenyellow;font-size:12px;\">" + debit + "</td>\n          <td class=\"numeric-cell\" style=\"color:#FF3737;font-size:12px;\">" + credit + "</td>\n        </tr>\n\n        ";
        }

        $(".content-financial").html(financialCard);
      }
    });
  };

  $on('pageInit', function () {
    checkFinancial();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">

      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Transaction</div>

    </div>
  </div>
  <div class="page-content"  style="background: linear-gradient(45deg, #121212 0%, #121212 100%);">



    <div class="card data-table" style="margin: 0px;background-color: #151924;">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Time</th>
            <th class="label-cell">Description</th>
            <th class="label-cell">Debit</th>
            <th class="label-cell">Credit</th>
          </tr>
        </thead>
        <tbody class="content-financial">
          <tr>
            <td class="label-cell">Loading...</td>
            <td class="numeric-cell"></td>
            <td class="numeric-cell"></td>
            <td class="numeric-cell"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <br/>

    
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '054306df63';
export default framework7Component;